import * as PIXI from "pixi.js";
import { DrawingTool } from "../../../types/Enum";
import { drawPencil } from "../../../../../../../src/entities/UI/Pencil";
import { DrawingIconsResponse } from "../../../types/Interface";
import genCoordFromAngle from "../../../../../../../src/utils/coord/genCoordFromAngle";


export function getHeader(text: string) {
  const header = new PIXI.Text({ text })
  header.style = {
    fontWeight: "600",
    fontSize: 30
  }
  header.anchor.set(.5);
  header.position.set(0, -68)
  header.eventMode = "none";
  return header
}

export function generateDrawingIcons(): DrawingIconsResponse[] {
  const graphs = {
    line: new PIXI.Graphics(),
    point: new PIXI.Graphics(),
    pencil: new PIXI.Graphics(),
    compass: new PIXI.Graphics()
  }
  const line = DrawingToolsManagerFactory.drawStandartLine(graphs.line, 0x000000);
  //const linedouble = DrawingToolsManagerFactory.drawLine(9, 0xCCCCCC);
  //const lineWithDirSym = DrawingToolsManagerFactory.drawLineWithDirSym(6, 0xFF0000);
  const point = DrawingToolsManagerFactory.drawPoint(graphs.point, 0x000000);
  const CLR = DrawingToolsManagerFactory.createCLRText();
  const returnBack = DrawingToolsManagerFactory.drawreturn();
  const pencil = DrawingToolsManagerFactory.drawPencilIcon(graphs.pencil, 0x000000);
  const ruler = DrawingToolsManagerFactory.drawRuler();
  const protractor = DrawingToolsManagerFactory.drawProtractor();
  const compass = DrawingToolsManagerFactory.drawCompass(graphs.compass, 0x000000);

  return [
    // { icon: linedouble, name: DrawingTool.doubleLine },
    { icon: line, name: DrawingTool.line },
    { icon: pencil, name: DrawingTool.pencil },
    { icon: point, name: DrawingTool.point },
    { icon: returnBack, name: DrawingTool.returnBack },
    // { icon: lineWithDirSym, name: DrawingTool.lineWithDirSym },
    { icon: protractor, name: DrawingTool.protractor },
    { icon: ruler, name: DrawingTool.ruler },
    { icon: compass, name: DrawingTool.compass },
    { icon: CLR, name: DrawingTool.clear },
  ];
}

export default class DrawingToolsManagerFactory {
  static drawStandartLine(line: PIXI.Graphics, color: number) {
    return this.drawLine(line, 6, color);
  }
  static drawLine(line: PIXI.Graphics, width: number, color: number) {
    return line
      .clear()
      .moveTo(-15, 15)
      .lineTo(15, -15)
      .stroke({ color, width, cap: "round" });
  }
  /* static drawLineWithDirSym(width: number, color: number) {
     return this.drawLine(width, color)
       .moveTo(-12, -3)
       .lineTo(3, -3)
       .lineTo(3, 12)
       .stroke({ color, width, cap: "round" })
   }*/
  static drawPoint(circle: PIXI.Graphics, color: number) {
    return circle
      .clear()
      .circle(0, 0, 13)
      .fill(color);
  }
  static createCLRText() {
    const clrText = new PIXI.Text({ text: "CLR" })
    clrText.anchor.set(.5);
    return clrText;
  }
  static drawreturn() {
    return new PIXI.Graphics()
      .arc(0, 0, 15, -Math.PI / 2, Math.PI)
      .stroke({ width: 4, color: 0x000000 })

      .moveTo(0, -20)
      .lineTo(-12, -10)
      .lineTo(3, -8)
      .fill(0x000000);
  }
  static drawPencilIcon(pencil: PIXI.Graphics, color: number) {
    drawPencil(pencil, color, { x: 0, y: 15 });
    pencil.rotation = Math.PI / 4;
    return pencil;
  }
  static drawRuler() {
    const rulerIcon = new PIXI.Graphics();
    rulerIcon
      .moveTo(-24, -7)
      .lineTo(-24, 7)
      .lineTo(24, 7)
      .lineTo(24, -7)
      .fill(0xFC99C4);

    Array(7).fill(null).forEach((e, eI) => {
      const x = -24 + (eI + 1) * 6;
      rulerIcon
        .moveTo(x, -7)
        .lineTo(x, -1)
        .stroke({ width: 1, color: 0x000000, alpha: .6 })
    });
    rulerIcon.rotation = -Math.PI / 4;
    return rulerIcon
  }
  static drawProtractor() {
    const unitAngle = -Math.PI / 10;
    const radius = 25;
    const protractor = new PIXI.Graphics();
    protractor
      .moveTo(0, 7)
      .arc(0, 7, radius, Math.PI, 0)
      .lineTo(radius, 7)
      .lineTo(-radius, 7)
      .fill(0xFC99C4);
    Array(9).fill(null).forEach((e, eI) => {
      const rad = unitAngle * (eI + 1);
      const startCoord = genCoordFromAngle(rad, 25)
      const endCoord = genCoordFromAngle(rad, 18)

      protractor
        .moveTo(startCoord.x, startCoord.y + 7)
        .lineTo(endCoord.x, endCoord.y + 7)
        .stroke({ width: 1, color: 0x000000, alpha: .6 })
    })
    protractor.rotation = -Math.PI / 4;
    return protractor;
  }
  static drawCompass(compass: PIXI.Graphics, color: number) {

    const BLUE = 0x0195b8;
    const DARK_BLUE = 0x015f78
    compass
      .clear()
      .moveTo(-16, 24)
      .lineTo(0, -11)
      .stroke({ width: 2, color: 0xD0D0D0 })

      // pencil start
      .moveTo(14, 18)
      .lineTo(11, -11)
      .stroke({ width: 4, color: color })

      .moveTo(14, 24)
      .lineTo(12, 18)
      .lineTo(16, 18)
      .lineTo(14, 24)
      .fill(0xD0D0D0)
      // pencil end

      // left leg
      .moveTo(-12, 16)
      .lineTo(0, -11)
      .stroke({ width: 5, color: BLUE, cap: "round" })

      // right leg start
      .moveTo(18, 8)
      .lineTo(10, 10)
      .lineTo(0, -11)
      .stroke({ width: 4, color: BLUE, cap: "round" })

      .moveTo(16, 4)
      .lineTo(18, 12)
      .stroke({ width: 2, color: DARK_BLUE })
      // right leg end

      // head start
      .moveTo(0, -11)
      .lineTo(0, -25)
      .stroke({ width: 2, color: DARK_BLUE, cap: "round" })

      .moveTo(0, -11)
      .lineTo(0, -17)
      .stroke({ width: 6, color: DARK_BLUE, cap: "round" })

      .moveTo(0, -14)
      .circle(0, -14, 1.5)
      .fill(0xD0D0D0)
    // head end

    return compass
  }

}